














































































































































































































































import { defineComponent, watch, reactive, ref, computed, onBeforeMount } from '@vue/composition-api';
import { LearnerEndOfYearStoreKey, LearnerStoreKey, UserStoreKey } from '@/store/StoreInjectionKeys';
import { injectStrict } from '@/lib/utils';
import AgTable from '@/modules/ees/components/AgTable.vue';
import RatingScaleReferenceChart from '@/modules/ees/components/RatingScaleReferenceChart.vue';
import RatingPerformanceLevelText from '@/modules/ees/pages/activity/components/RatingPerformanceLevelText.vue';
import DownloadArtifactLinkColumn from './components/DownloadArtifactLinkColumn.vue';
import EndOfYearEvidenceFullWidthRow from './components/EndOfYearEvidenceFullWidthRow.vue';
import { RubricHelper } from '@/modules/ees/helpers/rubricHelper'

export default defineComponent({
  name: 'LearnerEndOfYear',
  components: {
    AgTable,
    RatingScaleReferenceChart,
    RatingPerformanceLevelText,
    DownloadArtifactLinkColumn,
    EndOfYearEvidenceFullWidthRow
  },
  setup(props, { root }) {
    const learnerEndOfYearStore = injectStrict(LearnerEndOfYearStoreKey);
    const learnerStore = injectStrict(LearnerStoreKey);
    const userStore = injectStrict(UserStoreKey);
    const rubricHelper: RubricHelper = new RubricHelper()
    learnerEndOfYearStore.actions.hydrateEndOfYearRatings();

    const canViewTeacherGrowth = computed(() => {
      return userStore.getters.isDistrictAdmin()
        || userStore.getters.isSchoolAdmin()
        || (userStore.getters.isLearner() && userStore.state.UserId === userStore.state.ContextUserId)
        || (userStore.getters.isObserver() && userStore.getters.isObserving());
    });

    watch(() => [userStore.state.ContextUserId, canViewTeacherGrowth.value], ([, canView]) => {
      if (canView) {
        learnerStore.actions.getLearnerGrowthSummary();
      }
    }, { immediate: true });

    const growthSummary = computed(() => canViewTeacherGrowth.value ? learnerStore.state.learnerGrowthSummary : null);
    const growthFiscalYear = computed(() => {
      if (!growthSummary.value) {
        return '';
      }
      return String(growthSummary.value.fiscalYear + 1990);
    });
    const formatGrowthValue = (value?: number | null): string => {
      if (value === undefined || value === null) {
        return 'N/A';
      }
      return value.toFixed(2);
    };

    const formatDateTime = (value?: Date | string | null): string => {
      if (!value) {
        return '';
      }

      const date = value instanceof Date ? value : new Date(value);
      if (Number.isNaN(date.getTime())) {
        return '';
      }

      return date.toLocaleString('en-US');
    };

    const endOfYearId = root.$route.params.endOfYearId
    const isActive = ref(!endOfYearId && (userStore.getters.isObserver() && userStore.getters.isObserving()))
    const finalize = ref(learnerEndOfYearStore.actions.validateRating());
    const finalizeText = ref(learnerEndOfYearStore.actions.validateRating() ? 'Reopen' : 'Finalize');
    const showValidationModal = ref(false)
    const selectedCounter = ref(0)
    const totalComponentCounter = ref(0)

    watch(() => learnerEndOfYearStore.state.currentEndOfYearRating.isFinalized, (isFinalized) => {
      finalize.value = isFinalized ?? false;
      finalizeText.value = finalize.value ? 'Reopen' : 'Finalize';
    });
    

    watch(() => root.$route.params.learnerId, async (learnerId, oldLearnerId) => {
      console.log(learnerId)
      if (learnerId !== oldLearnerId) {
        await learnerEndOfYearStore.actions.hydrateEndOfYearRatings();
        if (endOfYearId) {
          await learnerEndOfYearStore.actions.setCurrentEndOfYearRating(parseInt(endOfYearId))   
        }
      }
    });

    watch(() => learnerEndOfYearStore.state.currentEndOfYearRatingRubricVersionId, async (rvId) => {
      console.log(`Rubric Version Id ${rvId}`)
      await rubricHelper.loadRubricVersion(rvId)
      if (endOfYearId) {
        learnerEndOfYearStore.actions.setCurrentEndOfYearRating(parseInt(endOfYearId))
      }
    }, { immediate: true });

    watch(() => endOfYearId, async (id) => {
      console.log(`End of Year Id ${endOfYearId}`)
      if (id) {
        // Hack around race condition I cannot figure out
        setTimeout(function() {
          learnerEndOfYearStore.actions.setCurrentEndOfYearRating(parseInt(endOfYearId))
        }, 2000);
      }
    }, { immediate: true })

    function setComponentRatingSelectedBy(domainKey: string, componentKey: string): void {
      learnerEndOfYearStore.actions.setComponentRatingSelectedBy(domainKey, componentKey);
    }

    function checkForReset(domainKey: string | undefined, componentKey: string, componentSelectedLevel: number, performanceLevelLevel: number): void {
      if (componentSelectedLevel === performanceLevelLevel) {
        learnerEndOfYearStore.actions.resetComponentRating(domainKey, componentKey);
      }
    }

    function printThisPage(): void {
      window.print();
    }

    function resetEndOfYearRating(): void {
      if (window.confirm('Are you sure you want to reset this learner\'s annual rating to align with the currently assigned rubric?')) {
        learnerEndOfYearStore.actions.resetEndOfYearRating(learnerEndOfYearStore.state.currentEndOfYearRatingId)
      }
    }

    // The TESS framework's "Professional Responsibilities" domain (always domain 4) is not
    // part of the annual composite score, so it is locked out here for entry. Detecting by
    // domain name (rather than rubric name) avoids rubric-name inconsistencies (e.g. "AR Tess...").
    function isDomainScoreExcluded(domainKey: string): boolean {
      return rubricHelper.domainName(domainKey) === 'Professional Responsibilities';
    }

    function disableRating(domainKey?: string): boolean {

      if (domainKey !== undefined && isDomainScoreExcluded(domainKey)) {
        return true;
      }

      if(!isActive.value) {
        return true;
      }
      else{
        return finalize.value;
      }
    }

    function toggleFinalize(): void {

      selectedCounter.value = 0;
      totalComponentCounter.value = 0;
      learnerEndOfYearStore.getters.getEndOfYearRating().rating?.domains?.forEach(d => {
        if(d.components){
          totalComponentCounter.value += d.components.length
          d.components.forEach(c => {
            if (c.selectedLevel != null) {
              ++selectedCounter.value;
            }        
          });
        }
      });

      if(selectedCounter.value >= 4 || finalize.value){
        learnerEndOfYearStore.actions.setFinalized(!finalize.value);
        showValidationModal.value = false;
      }
      else {
        showValidationModal.value = true;
      } 
    }

    const evidenceTable = reactive({
      columnDefs: [
        {
          headerName: 'Notes',
          field: 'notes',
          flex: 1
        },
        {
          headerName: 'Comments',
          field: 'comments',
          flex: 1
        },
        {
          headerName: 'Created By',
          field: 'createdBy',
        },
        {
          headerName: 'Created Date',
          field: 'createdDate',
          type: ['dateColumn']
        }
      ],
      fullWidthCellRenderer: 'EndOfYearEvidenceFullWidthRow'
    });

    const ratingTable = reactive({
      columnDefs: [
        {
          headerName: 'Activity Name',
          field: 'activityName',
          flex: 1
        },
        {
          headerName: 'Rated By',
          field: 'ratedByName',
        },
        {
          headerName: 'SelectedLevel',
          field: 'selectedLevel',
        }
      ]
    });

    const artifactTable = reactive({
      columnDefs: [
        {
          headerName: "File Name",
          field: "name",
          flex: 2,
          cellRendererFramework: DownloadArtifactLinkColumn
        },
        {
          headerName: 'Uploaded By',
          field: 'createdBy',
        },
        {
          headerName: 'Uploaded Date',
          field: 'createdDate',
          type: ['dateColumn']
        }
      ]
    });

    const promptTable = reactive({
      columnDefs: [
        {
          headerName: 'Prompt',
          field: 'promptText',
          flex: 1,
          autoHeight: true,
          wrapText: true,   
          cellStyle: { wordBreak: 'normal' },
        },
        {
          headerName: 'Response',
          field: 'response',
          flex: 1,
          autoHeight: true,
          wrapText: true,  
          cellStyle: { wordBreak: 'normal' },
        } 
      ]
    });

    return {
      setComponentRatingSelectedBy,
      checkForReset,
      printThisPage,
      resetEndOfYearRating,
      disableRating,
      toggleFinalize,
      showValidationModal,
      totalComponentCounter,
      selectedCounter,
      finalize,
      finalizeText,
      learnerEndOfYearStore,
      learnerStore,
      userStore,
      evidenceTable,
      ratingTable,
      artifactTable,
      promptTable,
      isActive,
      canViewTeacherGrowth,
      growthSummary,
      growthFiscalYear,
      formatGrowthValue,
      formatDateTime,
      rubricHelper,
      rubricMismatch: computed(() => userStore.state.ContextRubricId !== learnerEndOfYearStore.state.currentEndOfYearRatingRubricVersionId),
      endOfYearId,
      isDomainScoreExcluded
    }
  }
})
